/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * NOTE: using traditional object notation with prototype is not possible, because interceptors are not managed as
 * object instances, simply as standalone function containers. They are not considered
 * as stateful objects (at least the call of their functions is made in a procedural way, no scoping).
 */
/** @ngInject */
function HttpInterceptorFactory($rootScope, $q, $log, configuration) {
    const interceptor = {};

    /**
     * Intercepts HTTP responses with errors (4xx and 5xx status codes), and formats errors in a container. An HTTP
     * unauthorized event is sent in case of 401 HTTP status.
     *
     * @param {Object} response The response that caused the rejection.
     * @returns {Promise} A new rejected promise with the response.
     */
    interceptor.responseError = function(response) {
        switch (response.status) {
        case 401:
            // Do nothing in this case, error processing is delegated to someone else.
            $rootScope.$emit(configuration.UNAUTHORIZED_EVENT_NAME);
            break;
        case 403:
            // Delegate error processing to someone else.
            $rootScope.$emit(configuration.FORBIDDEN_EVENT_NAME);
            break;
        case 400:
        case 404:
        case 409:
            // Do nothing, client errors are handled by callers.
            break;
        default:
            // Delegate error processing to someone else.
            $rootScope.$emit(configuration.UNEXPECTED_STATUS_EVENT_NAME, response);
            break;
        }
        return $q.reject(response);
    };

    $log.debug('Factory \'HttpInterceptor\' loaded');
    return interceptor;
}

export { HttpInterceptorFactory };



// WEBPACK FOOTER //
// ./src/main/front/scripts/util/HttpInterceptor.js